import { render } from "./profileName.vue?vue&type=template&id=5f098c80&scoped=true"
import script from "./profileName.vue?vue&type=script&lang=js"
export * from "./profileName.vue?vue&type=script&lang=js"

import "./profileName.vue?vue&type=style&index=0&id=5f098c80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f098c80"]])

export default __exports__